<app-navbar [title]="'PRODUCT_LIST.PAGE_TITLE' | translate" [backLink]="'/'" [showBackButton]="true" [showLogout]="true">
</app-navbar>

<div class="body">
  <!-- Mobile: Dropdown filter (shown only on small screens) -->
  <div class="mobile-filter-dropdown">
    <mat-form-field appearance="outline" class="form-field-full-width">
      <mat-label>{{ 'PRODUCT_LIST.SELECT_PRODUCT' | translate }}</mat-label>
      <mat-select [value]="activeTab" (selectionChange)="setTab($event.value)">
        <!-- <mat-option [value]="''">
          {{ 'PRODUCT_LIST.ALL' | translate }}
        </mat-option> -->
        <mat-option *ngFor="let product of products" [value]="product.productId">
          {{ product.nameLa }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Desktop: Horizontal tabs (hidden on mobile) -->
  <div class="tab-buttons button-scroll desktop-tabs">
    <button class="tab-buttons" [class.active]="activeTab === ''" (click)="setTab('')">
      {{ 'PRODUCT_LIST.ALL' | translate }}
    </button>
    <button
      *ngFor="let product of products"
      class="tab-buttons"
      [class.active]="activeTab === product.productId"
      (click)="setTab(product.productId)"
    >
      {{ product.nameLa }}
    </button>
  </div>

  @if (loading) {
  <div class="text-center py-5 loading-container">
    <mat-spinner diameter="50"></mat-spinner>
    <p class="la-font mt-3">{{ 'PRODUCT_LIST.LOADING_DATA' | translate }}</p>
  </div>
  }

  <!-- All view: grouped by product family — scan by type, swipe within a family -->
  @if (!activeTab) {
    <!-- Featured strip: the worth-it plans, first thing seen on open -->
    @if (featuredPlans.length > 0) {
      <div class="product-group featured-group">
        <div class="product-group-header">
          <h4><i class="fa-solid fa-star featured-star"></i> {{ 'PRODUCT_LIST.FEATURED_TITLE' | translate }}</h4>
          <span class="group-count">{{ 'PRODUCT_LIST.FEATURED_SUBTITLE' | translate }}</span>
        </div>
        <div class="group-grid">
          @for (item of featuredPlans; track item.planId) {
            <ng-container *ngTemplateOutlet="planCard; context: { $implicit: item, i: $index }"></ng-container>
          }
        </div>
      </div>
    }

    @for (group of productGroups; track group.productId) {
      @if (group.plans.length > 0) {
        <div class="product-group">
          <div class="product-group-header">
            <h4>{{ group.name }}</h4>
            <span class="group-count">{{ group.plans.length }} {{ 'PRODUCT_LIST.PLANS' | translate }}</span>
          </div>
          <div class="group-grid">
            @for (item of group.plans; track item.planId) {
              <ng-container *ngTemplateOutlet="planCard; context: { $implicit: item, i: $index }"></ng-container>
            }
          </div>
        </div>
      }
    }
  } @else {
    <div class="box">
      @for (item of filteredPlans; track item.planId) {
        <ng-container *ngTemplateOutlet="planCard; context: { $implicit: item, i: $index }"></ng-container>
      }
    </div>
  }

  <!-- Shared plan card: text-first (marketing posters removed — unreadable at card size) -->
  <ng-template #planCard let-item let-i="i">
    <div
      class="plan-card card-anim"
      [style.animation-delay.ms]="staggerDelay(i)"
      routerLink="/I4UProductPlanDetail/{{ item.productId }}/{{ item.planId }}"
      role="link"
      [attr.aria-label]="item.planName"
    >
      <div class="plan-card-top">
        <div class="plan-icon"><i class="fa-solid {{ productIcon(item.productId) }}"></i></div>
        <div class="plan-titles">
          <h3 [title]="item.planName">{{ item.planName }}</h3>
          <!-- Independent badges: a plan that is BOTH best-selling and best-value shows both -->
          @if (isPopular(item.planId) || bestValueIds.has(item.planId)) {
            <div class="plan-badges">
              @if (isPopular(item.planId)) {
                <span class="plan-badge-inline badge-popular">🔥 {{ 'PRODUCT_LIST.BADGE_POPULAR' | translate }}</span>
              }
              @if (bestValueIds.has(item.planId)) {
                <span class="plan-badge-inline badge-value">★ {{ 'PRODUCT_LIST.BADGE_BEST_VALUE' | translate }}</span>
              }
            </div>
          }
        </div>
      </div>

      <div class="plan-coverage">
        <span class="cov-label">{{ 'PRODUCT_LIST.BENEFITS' | translate }}</span>
        <span class="cov-value">
          @if(item.minCoverageAmt == item.maxCoverageAmt){ {{ item.minCoverageAmt | number }} }
          @else { @if(item.minCoverageAmt > 0){ {{ item.minCoverageAmt | number }} - }@else{ {{ 'PRODUCT_LIST.MAXIMUM' | translate }} } {{ item.maxCoverageAmt | number }} }
          <small>₭</small>
        </span>
      </div>

      <div class="plan-price">
        <span class="pp-label">{{ 'PRODUCT_LIST.FROM_ONLY' | translate }}</span>
        <span class="pp-value">{{ perDay(item.premiumPerYear) | number }} <small>{{ 'PRODUCT_LIST.KIP_PER_DAY' | translate }}</small></span>
        <i class="fa-solid fa-chevron-right pp-go"></i>
      </div>
    </div>
  </ng-template>
</div>
